import Pie2d from"@fusioncharts/charts/src/chart/pie2d";export default Pie2d;


//////////////////
// WEBPACK FOOTER
// ./~/fusioncharts/viz/pie2d.js
// module id = sc6x
// module chunks = 5